const SendMessageIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.0358 21.6856C15.0738 21.7803 15.1398 21.861 15.2251 21.9171C15.3103 21.9732 15.4107 22.0018 15.5126 21.9992C15.6146 21.9966 15.7134 21.9628 15.7956 21.9025C15.8779 21.8421 15.9397 21.7581 15.9728 21.6616L22.4728 2.66157C22.5048 2.57296 22.5109 2.47707 22.4904 2.38512C22.4699 2.29317 22.4236 2.20896 22.357 2.14235C22.2904 2.07573 22.2062 2.02946 22.1143 2.00896C22.0223 1.98846 21.9264 1.99456 21.8378 2.02657L2.83781 8.52657C2.7413 8.55966 2.65723 8.62149 2.59688 8.70374C2.53652 8.78599 2.50278 8.88474 2.50016 8.98673C2.49755 9.08871 2.5262 9.18906 2.58226 9.27429C2.63833 9.35953 2.71912 9.42558 2.81381 9.46357L10.7438 12.6436C10.9945 12.7439 11.2223 12.894 11.4134 13.0848C11.6045 13.2756 11.755 13.5031 11.8558 13.7536L15.0358 21.6856Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3541 2.14746L11.4141 13.0865"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SendMessageIcon;
